module.exports = __webpack_public_path__ + "img/aside-bg.17502cda.png";